'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'industry-windows';
var width = 512;
var height = 512;
var aliases = [127981,"industry-alt"];
var unicode = 'f3b3';
var svgPathData = 'M8 32l-8 0 0 448 512 0 0-381.6-11.9 6.7-164.1 91.9 0-98.8-12 7-164 95.6 0-168.7-152 0zm8 224l0-208 128 0 0 180.6 12-7 164-95.6 0 98.3 11.9-6.7 164.1-91.9 0 338.4-480 0 0-208zm80 56l-8 0 0 80 80 0 0-80-72 0zm8 64l0-48 48 0 0 48-48 0zm112-64l0 80 80 0 0-80-80 0zm16 16l48 0 0 48-48 0 0-48zm120-16l-8 0 0 80 80 0 0-80-72 0zm8 64l0-48 48 0 0 48-48 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIndustryWindows = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;